import getApiClient from '@/plugins/api-client'

export default {
  loadFaqs () {
    const api = getApiClient(this.$store)

    api.get('faqs')
      .then(result => {
        this.faqs = result.data['hydra:member']
      })
      .catch(error => {
        this.error = error
      })
  },

  saveSorting () {
    const api = getApiClient(this.$store)

    const data = {}

    this.faqs.forEach((faq, index) => {
        data[faq['@id']] = index
    })

    api.put('faq/sort', data)
      .then(() => {
        this.orderChanged = false
        this.$store.commit('app/raiseSuccess', 'Ordem atualizada')
      })
      .catch(error => {
        this.error = error
        this.$store.commit('app/raiseError', 'Erro ao salvar ordenação. Tente novamente')
      })
  },

  askDelete (faqId) {
    this.showDeleteDialog = true
    this.deletingId = faqId
  },

  cancelDelete () {
    this.showDeleteDialog = false
    this.deletingId = null
  },

  confirmDelete () {
    if (!this.deletingId) {
      return
    }

    const api = getApiClient(this.$store)

    api.delete(this.deletingId)
      .then(result => {
        if (result.status === 204) {
          this.$store.commit('app/raiseSuccess', 'Pergunta excluída')
          this.loadFaqs()
        }
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao excluir pergunta')
        this.loadFaqs()
      })
      .finally(() => {
        this.cancelDelete()
      })
  },
}
